//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/OpenXml.js";
import "../OpenXml/OpenXml.DocumentData.js";
let d=[[],[[[],"Dispose",{},0,0],[["textContent"],"AddText",{R_:{data:"OpenXml.TextDocumentData"}},1,0],[[],"AddImageGroup",{R_:{data:"OpenXml.ImageGroupDocumentData"}},0,0],[["columnCount","rowCount"],"AddTable",{R_:{data:"OpenXml.TableDocumentData"}},2,0],[[],"GetDataCount",{R_:{dataCount:''}},0,0],[["index"],"GetNthData",{R_:{data:"OpenXml.DocumentData"}},1,0],[["index"],"DeleteNthData",{},1,0],[[],"DeleteAllData",{},0,0]],[]];
SPLM.OpenXml.DocumentDataGroup = class extends SPLM.OpenXml.DocumentData{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.OpenXml.DocumentDataGroup";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;